import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    loading: false,
    booking: {},
    bookingError: "",
    waiver: {},
    waiverError: "",
    accountUpdateSuccess: false
  },
  mutations: {
    SET_LOADING(state, payload) {
      state.loading = payload;
    },
    BOOKING_LOADED(state, payload){
      state.booking = payload;
    },
    BOOKING_ERROR(state, payload){
      state.bookingError = payload;
    },
    WAIVER_CREATED(state, payload){
      state.waiver = payload;
    },
    WAIVER_ERROR(state, payload){
      state.waiverError = payload;
    },
    ACCOUNT_UPDATE_SUCCESS(state, payload){
      state.accountUpdateSuccess = payload;
    }
  },
  actions: {
    getBookings: ({ commit }, data) => {
      commit("SET_LOADING", true);
      return new Promise((resolve, reject) => {
        Vue.prototype.$bookings
        .getBookingsByReference(data.accountId, data.email)
        .then(response => {
          commit("SET_LOADING", false);
          if(response.status == 200){
            commit("BOOKING_LOADED", response.data);
          } else {
            commit("BOOKING_ERROR", response.data.Message || "An error has occurred whilst retrieving your booking, please refresh and try again.");
          }
          resolve(response);
        })
        .catch(error => {
          commit("BOOKING_LOADED", {});
          commit("BOOKING_ERROR", error);
          commit("SET_LOADING", false);
        });
      });
    },
    getScanBookings: ({ commit }, data) => {
      commit("SET_LOADING", true);
      return new Promise((resolve, reject) => {
        Vue.prototype.$bookings
        .getBookingsByReferenceForToday(data.accountId, data.email)
        .then(response => {
          commit("SET_LOADING", false);
          if(response.status == 200){
            commit("BOOKING_LOADED", response.data);
          } else {
            commit("BOOKING_ERROR", response.data.Message || "An error has occurred whilst retrieving your booking, please refresh and try again.");
          }
          resolve(response);
        })
        .catch(error => {
          commit("BOOKING_LOADED", {});
          commit("BOOKING_ERROR", error);
          commit("SET_LOADING", false);
        });
      });
    },
    handleWaiverRequest: async ({ commit }, booking) => {
      commit("SET_LOADING", true);
      return new Promise((resolve, reject) => {
        Vue.prototype.$waivers
        .createWaiverRequest(booking)
        .then(response => {
          commit("SET_LOADING", false);
          if(response.status == 200){
            commit("WAIVER_CREATED", response);
          } else {
            commit("WAIVER_ERROR", response.data.Message || "An error has occurred whilst saving your waiver, please refresh and try again.");
          }

          resolve(response);
        })
        .catch(error => {
          commit("WAIVER_CREATED", []);
          commit("SET_LOADING", false);
        });
      });
    },
    updateBOSAccount: async ({ commit }, data) => {
      commit("SET_LOADING", true);
      return new Promise((resolve, reject) => {
        Vue.prototype.$accounts
        .updateAccount(data.accountId, data.fields)
        .then(response => {
          commit("ACCOUNT_UPDATE_SUCCESS", true);
          commit("SET_LOADING", false);
          resolve(response);
        })
        .catch(error => {
          commit("ACCOUNT_UPDATE_SUCCESS", false);
          commit("SET_LOADING", false);
        });
      });
    },
  },
  getters: {
    booking: state => {
      return state.booking;
    },
    bookingError: state => {
      return state.bookingError;
    },
    waiverError: state => {
      return state.waiverError;
    },
  }
})
